module.exports = __webpack_public_path__ + "img/2-7-park-mgm.454f0576.jpg";